import { createAppKit } from '@reown/appkit/react'
import { WagmiProvider } from 'wagmi'
import { bsc } from '@reown/appkit/networks' // Changed from arbitrum, mainnet
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { WagmiAdapter } from '@reown/appkit-adapter-wagmi'

// Setup queryClient
const queryClient = new QueryClient()

// Project ID from cloud.reown.com
const projectId = '6545183a7108cb76a00ce1ac4e1a5e11'

// Metadata object
const metadata = {
  name: 'BitSport',
  description: 'Where AI Meets Web3 Gaming: Play, Earn, Predict',
  url: 'https://app.bitsport.gg',
  icons: ['https://app.bitsport.gg/logo.png']
}

// Set the networks
const networks = [bsc] // Changed from mainnet, arbitrum

// Create Wagmi Adapter with enhanced configuration for persistence
export const wagmiAdapter = new WagmiAdapter({
  networks,
  projectId,
  ssr: false,
  walletConnectProjectId: projectId,
  showBalance: true,
  showAddress: true,
  autoConnect: true,
  persistence: {
    enabled: true,
    storage: 'localStorage'
  }
})

// Create AppKit instance with all required functionality
const appKitInstance = createAppKit({
  adapters: [wagmiAdapter],
  networks,
  projectId,
  metadata,
  features: {
    analytics: true,
    persistence: {
      enabled: true,
      storage: 'localStorage'
    },
    signatureCache: true,
    connection: {
      autoConnect: true,
      reconnect: true,
      persistentSessions: true,
      sessionExpiry: 14 * 24 * 60 * 60 * 1000, // 14 days in milliseconds
      reconnectOnRefresh: true
    },
    balance: {
      enabled: true,
      networks: [bsc],
      tokens: ['native']
    }
  },
  sessionPersistence: {
    enabled: true,
    persistSignatures: true,
    expiry: 14 * 24 * 60 * 60 * 1000 // 14 days in milliseconds
  }
})

// Export the AppKit instance with all its methods
export const appKit = {
  ...appKitInstance,
  useWallet: appKitInstance.useWallet,
  connect: async () => {
    const connection = await appKitInstance.connect();
    // Wait for provider to be ready
    if (!appKitInstance.provider) {
      await new Promise(resolve => setTimeout(resolve, 1000));
    }
    return connection;
  },
  waitForTransaction: appKitInstance.waitForTransaction,
  provider: appKitInstance.provider
};

// Export other constants that might be needed
export const defaultChain = bsc
export { networks }

export function AppKitProvider({ children }) {
  return (
    <WagmiProvider config={wagmiAdapter.wagmiConfig}>
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </WagmiProvider>
  )
}
